module.exports = __webpack_public_path__ + "static/media/NTU-logo.0d9bacfe.jpg";